import * as Dat from 'dat.gui';
import { Scene, Color, Vector3, Fog, MathUtils, AmbientLight } from 'three';
import { Flower, Land, Floor, Crosshair, Ems1, Ems2, Ems3, Ems4, Shot, Effect, Tower, PowerUp, Bomb} from 'objects';
import { BasicLights } from 'lights';

class SeedScene extends Scene {
    constructor() {
        // Call parent Scene() constructor
        super();


        // Init state
        this.state = {
            gui: new Dat.GUI(), // Create GUI for scene
            updateList: [],
            playerPos: new Vector3(0,0,0),
            playerV: new Vector3(0,0,0),
            cameraP: new Vector3(0,0,0),
            colliders: [],
            effects: [],
            dist: 0,
            damage: 2,
            impact: new Vector3(0,0,0),
            target: undefined,
            fire: this.fire.bind(this),
            reset: this.reset.bind(this),
            powerUp: this.powerUp.bind(this),
            kill: this.kill.bind(this),
            prevSpawn: 0,
            alt: false,
            hurt: false,
            timerOffset: 0,
            timer: 0,
            next: true,
            waves: 0,
            total_waves: 2,
            tower: new Vector3(0,0,0),
            score: 0,
            mult: 1,
            timer2: 0.0,
            shots: [],
            index: 0,
            expSound: undefined,
            aSound: undefined,
            power1: -1,
            power2: -1,
            power3: -1,
        };

        // Set background to a nice color
        this.background = new Color(0x0);

        // Add meshes to scene
        const flower = new Flower(this);
        const floor = new Floor(this);
        const cross = new Crosshair(this);
        const shot1 = new Shot(this);
        const shot2 = new Shot(this);
        const shot3 = new Shot(this);
        const shot4 = new Shot(this);
        const shot5 = new Shot(this);
        const effect1 = new Effect(this);
        const tower = new Tower(this);
        const bomb = new Bomb(this);

        this.state.effects.push(effect1);
        this.state.shots.push(shot1);
        this.state.shots.push(shot2);
        this.state.shots.push(shot3);
        this.state.shots.push(shot4);
        this.state.shots.push(shot5);

        this.add(flower, floor, cross, shot1, shot2, shot3, shot4, shot5, effect1, tower, bomb);
        this.state.playerPos = flower.position;
        this.fog = new Fog( 0x0, 10, 200 ); 
    }


    addToUpdateList(object) {
        this.state.updateList.push(object);
    }

    addToColliderList(object) {
        this.state.colliders.push(object);
    }

    reset(){
        this.state.hurt = false;
        while(this.children.length > 0){ 
            this.remove(this.children[0]); 
        }

        this.state.updateList = [];
        this.state.colliders = [];
        this.state.effects = [];
        this.state.shots = [];
        this.state.power1 = -1;
        this.state.power2 = -1;
        this.state.power3 = -1;
        this.state.score = 0;

        const flower = new Flower(this);
        const floor = new Floor(this);
        const cross = new Crosshair(this);
        const shot1 = new Shot(this);
        const shot2 = new Shot(this);
        const shot3 = new Shot(this);
        const shot4 = new Shot(this);
        const shot5 = new Shot(this);
        const effect1 = new Effect(this);
        const lights = new BasicLights();
        const tower = new Tower(this);
        const bomb = new Bomb(this);
        cross.state.offset = this.state.timer;
        this.state.effects.push(effect1);

        this.state.shots.push(shot1);
        this.state.shots.push(shot2);
        this.state.shots.push(shot3);
        this.state.shots.push(shot4);
        this.state.shots.push(shot5);

        this.state.index = 0;

        this.add( flower, floor, cross, shot1, shot2, shot3, shot4, shot5, effect1, lights, tower, bomb);
        this.state.playerPos = flower.position;

        this.state.damage = 2;
        this.state.prevSpawn = this.state.timer;
        this.state.timerOffset = this.state.timer;
        this.state.waves = 0;
        this.state.total_waves = 2;
    }

    kill(){
        this.state.effects[0].set();
        this.state.effects[0].position.copy(this.state.target.position);
        this.state.expSound.play();
        if (this.state.target.name == "ems1"){
            this.state.effects[0].state.mat.color.r = 1;
            this.state.effects[0].state.mat.color.g = 0;
            this.state.effects[0].state.mat.color.b = 0;
            this.state.score += 1*this.state.mult;
        }
        if (this.state.target.name == "ems2"){
            this.state.effects[0].state.mat.color.r = 1;
            this.state.effects[0].state.mat.color.g = 0.5;
            this.state.effects[0].state.mat.color.b = 0;
            this.state.score += 1*this.state.mult;
        }
        if (this.state.target.name == "ems3"){
            this.state.effects[0].state.mat.color.r = 0.4;
            this.state.effects[0].state.mat.color.g = 0.7;
            this.state.effects[0].state.mat.color.b = 0.1;
            this.state.score += 2*this.state.mult;
        }
        if (this.state.target.name == "ems4"){
            this.state.effects[0].state.mat.color.r = 0.1;
            this.state.effects[0].state.mat.color.g = 0.4;
            this.state.effects[0].state.mat.color.b = 0.7;
            this.state.score += 2*this.state.mult;
        }
        if (this.state.target.name == "powerUp"){
            this.state.effects[0].state.mat.color.r = 0.6;
            this.state.effects[0].state.mat.color.g = 0.2;
            this.state.effects[0].state.mat.color.b = 0.8;
            if (this.state.power1 > 0) this.getObjectByName("flower").state.pow1.visible = true;
            if (this.state.power2 > 0) this.getObjectByName("flower").state.pow2.visible = true;
            if (this.state.power3 > 0) this.getObjectByName("flower").state.pow3.visible = true;
            if (this.state.power1 == 1) this.getObjectByName("flower").state.pow1.material.color = new Color("rgb(255, 50, 50)");
            if (this.state.power1 == 2) this.getObjectByName("flower").state.pow1.material.color = new Color("rgb(50, 50, 255)");
            if (this.state.power1 == 3) this.getObjectByName("flower").state.pow1.material.color = new Color("rgb(50, 255, 50)");
            if (this.state.power2 == 1) this.getObjectByName("flower").state.pow2.material.color = new Color("rgb(255, 50, 50)");
            if (this.state.power2 == 2) this.getObjectByName("flower").state.pow2.material.color = new Color("rgb(50, 50, 255)");
            if (this.state.power2 == 3) this.getObjectByName("flower").state.pow2.material.color = new Color("rgb(50, 255, 50)");
            if (this.state.power3 == 1) this.getObjectByName("flower").state.pow3.material.color = new Color("rgb(255, 50, 50)");
            if (this.state.power3 == 2) this.getObjectByName("flower").state.pow3.material.color = new Color("rgb(50, 50, 255)");
            if (this.state.power3 == 3) this.getObjectByName("flower").state.pow3.material.color = new Color("rgb(50, 255, 50)");
        }
        var index = this.state.updateList.indexOf(this.state.target);
        this.state.updateList.splice(index, 1);
        index = this.state.colliders.indexOf(this.state.target);
        this.state.colliders.splice(index, 1);
        this.remove(this.state.target);
    }

    fire(){
        this.state.dist = 1000;
        const c = this.state.colliders;
        for (var i = 0; i<c.length; i++){
            c[i].state.collide();
        }
        if(this.state.dist < 1000 && this.state.target != undefined){
            this.state.target.takeDam();
            if (this.state.target.state.hp <= 0){
                this.kill();
            }
        } else{
            const rayO = this.state.cameraP.clone();
            const rayD = this.state.playerPos.clone();
            rayD.y += 10;
            rayD.sub(rayO);
            rayD.normalize();
            this.state.impact = rayO.clone().add(rayD.multiplyScalar(300));
        }
        //this.getObjectByName("shot").lookAt(this.state.impact);
        //const player = this.getObjectByName("shot").state;
        if (this.state.alt){
            this.state.alt = false;
            this.getObjectByName("flower").state.pos1.getWorldPosition(this.state.shots[this.state.index].position);
            this.getObjectByName("flower").state.pos1.material.color.g = 0.5;
            this.getObjectByName("flower").state.pos1.material.color.b = 0.3;
        } else {
            this.state.alt = true;
            this.getObjectByName("flower").state.pos2.getWorldPosition(this.state.shots[this.state.index].position);
            this.getObjectByName("flower").state.pos2.material.color.g = 0.5;
            this.getObjectByName("flower").state.pos2.material.color.b = 0.3;
        }
        this.state.shots[this.state.index].lookAt(this.state.impact);
        this.state.shots[this.state.index].state.line1.visible = true;
        this.state.shots[this.state.index].state.line2.visible = false;
        this.state.shots[this.state.index].state.line2.scale.set(.1,.1,.1);
        this.state.shots[this.state.index].state.line2.material.opacity = 1.0;
        this.state.shots[this.state.index].state.impact = this.state.impact;
        this.state.index += 1;
        if (this.state.index >= 5) this.state.index = 0;

        if (this.getObjectByName("crosshair").state.lines.position.z < 15) this.getObjectByName("crosshair").state.lines.translateZ(10);
    }

    powerUp() {
        const ems1 = new PowerUp(this);
        ems1.position.x = MathUtils.randInt(-140, 140);
        ems1.position.z = MathUtils.randInt(-140, 140);
        while (ems1.position.distanceTo(this.state.playerPos) < 50){
            ems1.position.x = MathUtils.randInt(-140, 140);
            ems1.position.z = MathUtils.randInt(-140, 140);
        }
        ems1.position.y = 1;
        this.add(ems1);
    }

    update(timeStamp) {
        const { rotationSpeed, updateList } = this.state;
        this.state.timer = timeStamp;

        if (this.state.waves <= 0) this.state.next = true;
        if (this.state.hurt){
            this.getObjectByName("bomb").visible = false;
            if (this.getObjectByName("flower").state.cpow == 2){
                this.state.hurt = false;
                for (const obj of updateList) {
                    obj.update(timeStamp);
                }

            } else {
                this.state.playerV.copy(new Vector3(0,0,0));
                this.getObjectByName("crosshair").state.score = this.state.score;
                this.getObjectByName("crosshair").state.die();
            }
        } else {
            for (const obj of updateList) {
                obj.update(timeStamp);
            }
        }

        if (this.state.next) this.state.waves = 2;

        if (this.getObjectByName("flower").state.cpow == 3) this.state.playerV.multiplyScalar(1.02);

        this.getObjectByName("flower").position.add(this.state.playerV);

        this.getObjectByName("crosshair").position.add(this.state.playerV);
        this.getObjectByName("crosshair").lookAt(this.state.cameraP);
        this.getObjectByName("flower").state.velocity = this.state.playerV;
        this.state.playerPos.copy(this.getObjectByName("flower").position);

        if(timeStamp-this.state.timer2 > 20000){
            this.state.total_waves += 1;
            this.state.timer2 = timeStamp;
        }

        if (this.state.waves > 0 && timeStamp-this.state.prevSpawn > 1000 && this.state.hurt == false){
            this.state.prevSpawn = timeStamp;
            this.state.waves -= 1;
            const rng = MathUtils.randInt(0, 10);
            if (rng < 4){
                const ems1 = new Ems1(this);
                ems1.position.x = MathUtils.randInt(-140, 140);
                ems1.position.z = MathUtils.randInt(-140, 140);
                while (ems1.position.distanceTo(this.state.playerPos) < 50){
                    ems1.position.x = MathUtils.randInt(-140, 140);
                    ems1.position.z = MathUtils.randInt(-140, 140);
                }
                ems1.position.y = 1.5;
                this.add(ems1);
            }
            if (rng >= 4 && rng < 7){
                const ems1 = new Ems2(this);
                ems1.position.x = MathUtils.randInt(-140, 140);
                ems1.position.z = MathUtils.randInt(-140, 140);
                while (ems1.position.distanceTo(this.state.playerPos) < 50){
                    ems1.position.x = MathUtils.randInt(-140, 140);
                    ems1.position.z = MathUtils.randInt(-140, 140);
                }
                ems1.position.y = 10;
                this.add(ems1);
            }
            if (rng >= 7 && rng < 9){
                const ems1 = new Ems3(this);
                ems1.position.x = MathUtils.randInt(-140, 140);
                ems1.position.z = MathUtils.randInt(-140, 140);
                while (ems1.position.distanceTo(this.state.playerPos) < 50){
                    ems1.position.x = MathUtils.randInt(-140, 140);
                    ems1.position.z = MathUtils.randInt(-140, 140);
                }
                ems1.position.y = 1.5;
                this.add(ems1);
            }
            if (rng >= 9){
                const ems1 = new Ems4(this);
                ems1.position.x = MathUtils.randInt(-140, 140);
                ems1.position.z = MathUtils.randInt(-140, 140);
                while (ems1.position.distanceTo(this.state.playerPos) < 50){
                    ems1.position.x = MathUtils.randInt(-140, 140);
                    ems1.position.z = MathUtils.randInt(-140, 140);
                }
                ems1.position.y = 7.5;
                this.add(ems1);
            }

        }


    }


}

export default SeedScene;
